import React from "react";
import SelectAutocomplete from "./SelectAutocomplete";

const SelectAutocompleteFormik = ({
  formik,
  field,
  options,
  optionValue = "value",
  optionLabel = "label",
  maxOptions = 10,
}) => (
  <SelectAutocomplete
    options={options}
    optionValue={optionValue}
    optionLabel={optionLabel}
    maxOptions={maxOptions}
    disabled={formik.submitting}
    error={formik.touched[field] ? formik.errors[field] : null}
    value={formik.values[field]}
    onChange={(selectedValue) => formik.setFieldValue(field, selectedValue)}
  />
);

export default SelectAutocompleteFormik;
